import { render, staticRenderFns } from "./teacherComponent.vue?vue&type=template&id=57cf0681&scoped=true"
import script from "./teacherComponent.vue?vue&type=script&lang=js"
export * from "./teacherComponent.vue?vue&type=script&lang=js"
import style0 from "./teacherComponent.vue?vue&type=style&index=0&id=57cf0681&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cf0681",
  null
  
)

export default component.exports